import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import CategoryCRUD from './MovementCategory';

const ExpenseCategory = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado de Tipos de Movimientos' pageTitle='Tipos de Movimientos' />
                <CategoryCRUD />
            </div>
        </React.Fragment>
    )
}

export default ExpenseCategory;